import React from 'react';
import _ from 'lodash';
import parts from '../../../utilities/parts';

import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import { messageUtility } from '../../../utilities/messageUtility';
import { USER_ROLES } from '../../../utilities/constants';
import { isTargetRoleId } from '../../../utilities/roleUtility';

/**
 * ユーザー顔写真ヘッダー
 * @description WorekerHeader.jsxが作業員の顔写真と共通で使われていたが、ユーザー画面独自の制御を加える必要があるため複製
 * @props {object}LinkButtonObject:戻る etc... リンクのオブジェクト
 * LinkButtonObject プロパティに必要なプロパティ
 *   {string}label: テキスト
 *   {string}className: クラス名
 *   {function}onClick: 処理
 *
 * @props {object}buttonObject:ボタンオブジェクト
 * buttonObject プロパティに必要なプロパティ
 *   {string}label: テキスト
 *   {string}className: クラス名
 *   {function}onClick: 処理
 * @props {number} targetUserRoleId 表示編集対象となるユーザーのロールID
 * @props {number} operationUserRoleId 操作しているユーザーのロールID
 */
export class UserPhotoHeader extends React.Component {
  constructor(props) {
    super(props);

    // 戻る etc... リンクのオブジェクトの設定
    if (
      isNullOrUndefinedOrEmptyStr(this.props.LinkButtonObject) === false &&
      parts.isEmptyObject(this.props.LinkButtonObject) === false
    ) {
      // this.state.LinkButtonObject = this.props.LinkButtonObject;
      _.map(this.props.LinkButtonObject, obj => {
        if (
          isNullOrUndefinedOrEmptyStr(obj.onClick) === false &&
          _.isFunction(obj.onClick) === false
        ) {
          console.warn('onClick is not function');
          obj.onClick = null;
        }
      });
    }

    // 各ボタンの設定
    if (
      isNullOrUndefinedOrEmptyStr(this.props.buttonObject) === false &&
      parts.isEmptyObject(this.props.buttonObject) === false
    ) {
      _.map(this.props.buttonObject, obj => {
        if (
          isNullOrUndefinedOrEmptyStr(obj.onClick) === false &&
          _.isFunction(obj.onClick) === false
        ) {
          console.warn('onClick is not function');
          obj.onClick = null;
        }
      });
    }
  }

  /**
   * 顔画像情報が編集可能かを判定する
   * @return {boolean} true:可、false:不可
   */
  isEdittable = () => {
    if (_.isNil(this.props.targetUserRoleId)) {
      return false;
    }
    let result = false;
    // ユーザーの顔画像登録は元請けユーザーのみの機能のため
    // 元請けユーザーロールについてのみ記載
    switch (this.props.targetUserRoleId) {
      case USER_ROLES.prime.id:
        // 対象が本社管理者の場合は、本社管理者ユーザーのみ編集可能
        result = isTargetRoleId(
          [USER_ROLES.prime],
          this.props.operationUserRoleId
        );
        break;
      case USER_ROLES.branch.id:
        // 対象が本社管理者の場合は、本社管理者と支店管理者ユーザーのみ編集可能
        result = isTargetRoleId(
          [USER_ROLES.prime, USER_ROLES.branch],
          this.props.operationUserRoleId
        );
        break;
      case USER_ROLES.manager.id:
        // 現場監督は、元請け喉のロールでも編集可能
        result = true;
        break;
      default:
        break;
    }
    return result;
  };

  componentDidUpdate() {
    if (!_.isInteger(this.props.errorMessagesCount)) {
      throw new Error(
        'UserPhotoHeader.jsx props.errorMessagesCount is not integer'
      );
    }
  }

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <div className='contruction-detail-view__header'>
          {_.map(this.props.LinkButtonObject, (item, index) => {
            return (
              <span key={index}>
                <button className={item.className} onClick={item.onClick}>
                  <i className='i-back--blue i-2x vertical-middle' />
                  {item.label}
                </button>
              </span>
            );
          })}
        </div>
        <div className='contruction-detail-view__menu'>
          {this.isEdittable() && (
            <React.Fragment>
              {_.map(this.props.buttonObject, (item, index) => {
                let buttonClassName = item.className;
                if (index === 'register') {
                  if (this.props.errorMessagesCount >= 1) {
                    buttonClassName += ' btn--disabled';
                  }
                }
                if (item.isSetDisabled && this.props.isDisabled) {
                  buttonClassName += ' btn--disabled';
                }
                return (
                  <span
                    className='construction-detail-view__button'
                    key={index}
                  >
                    <button
                      className={buttonClassName}
                      onClick={item.onClick}
                      data-testid={
                        item.label === '更新' ? 'worker_header_edit' : ''
                      }
                    >
                      {item.label}
                    </button>
                  </span>
                );
              })}
            </React.Fragment>
          )}
          <span className='construction-detail-view__multiple-alert-text'>
            {this.props.errorMessagesCount === 0
              ? null
              : messageUtility.getMessage('E-000-014')}
          </span>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/worker/header/UserPhotoHeader.jsx